import { render, staticRenderFns } from "./CollapsibleDiv.vue?vue&type=template&id=5d0aa00e&"
import script from "./CollapsibleDiv.vue?vue&type=script&lang=js&"
export * from "./CollapsibleDiv.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleDiv.vue?vue&type=style&index=0&id=5d0aa00e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports